module.exports = "<p>\n  snackbar works!\n</p>\n"